import { ReviewPostPageStatePresenter } from '@/presentation/presenters/reviewPost/reviewPagePostStatePresenter'
import { ReviewPostPageStateViewModel } from '@/presentation/viewmodels/reviewPost/reviewPostPageStateViewModel'

export function useReviewPostPageStatePresenter(
  presenter: ReviewPostPageStatePresenter = new ReviewPostPageStatePresenter(new ReviewPostPageStateViewModel())
) {
  return {
    isFirstOpendPage: presenter.isFirstOpendPage,
    entrySummaryExpandedList: presenter.entrySummaryExpandedList,
    entrySelectedReviewIndexList: presenter.entrySelectedReviewIndexList,
    entryEditingList: presenter.entryEditingList,
    isSummaryExpanded: presenter.isSummaryExpanded.bind(presenter),
    isDetailSelected: presenter.isDetailSelected.bind(presenter),
    setIsFirstOpendPage: presenter.setIsFirstOpendPage.bind(presenter),
    setEntrySummaryExpandedFlag: presenter.setEntrySummaryExpandedFlag.bind(presenter),
    setEntrySelectedReviewIndex: presenter.setEntrySelectedReviewIndex.bind(presenter),
    reverseEntryEditingFlag: presenter.reverseEntryEditingFlag.bind(presenter)
  }
}
